import Cookies from "js-cookie";
const domain = "";
let expires = {
  path: "/",
  domain: domain,
  expires: new Date(new Date().getTime() + 2 * 60 * 60 * 1000),
};

export function clearToken() {
  Cookies.remove("CMS_WEB_STORE_TOKEN", expires);
}

export function getStoreToken() {
  return Cookies.get("CMS_WEB_STORE_TOKEN") || "";
}

export function setStoreToken(token) {
  Cookies.set("CMS_WEB_STORE_TOKEN", token, expires);
}

export function setRedirectUrl(url) {
  Cookies.set("CMS_WEB_COMBINE_REDIRECYT_URL", url, expires);
}

export function getRedirectUrl() {
  return Cookies.get("CMS_WEB_COMBINE_REDIRECYT_URL") || "";
}
export function clearRedirectUrl() {
  Cookies.remove("CMS_WEB_COMBINE_REDIRECYT_URL", expires);
}

export function setStoreUserObj(userInfo) {
  Cookies.set("CMS_USERINFO", JSON.stringify(userInfo || ""), expires);
}
export function getStoreUserObj() {
  if (Cookies.get("CMS_USERINFO")) {
    return JSON.parse(Cookies.get("CMS_USERINFO")) || "";
  } else {
    return "";
  }
}
